import React, { useEffect } from "react";
import { useState } from "react";
import Table from "../component/Table";
import ModalClinicModule from "./ModalClinicModule";
import API from "../../apiService";

const ClinicModule = () => {
  const [clinics, setClinics] = useState([]);
  const [clinicsAll, setClinicsAll] = useState([]);

  const [modules, setModules] = useState([]);
  const [paramedics, setParamedics] = useState([]);
  const [clinic, setClinic] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [refreshModal, setRefreshModal] = useState(0);
  const [search, setsearch] = useState("");

  useEffect(() => {
    getClinic();
    getModules();
    getParamedic();
  }, []);

  useEffect(() => {
    let find = [];
    if (search.length > 3) {
      let dt = clinics.filter((a) =>
        a.name.toLowerCase().includes(search.toLowerCase())
      );
      find = dt;
    }
    if (find.length > 0) {
      setClinics(find);
    }
    if (search.length < 3) {
      setClinics(clinicsAll);
    }
  }, [search]);

  const getClinic = async () => {
    const res = await API.get("management/clinics/read");
    if (res.code === 200) {
      setClinics(res.data);
      setClinicsAll(res.data);
    }
  };

  const getModules = async () => {
    const res = await API.get("management/modules/read");
    if (res.code === 200) {
      setModules(res.data);
    }
  };

  const getParamedic = async () => {
    const res = await API.get("management/paramedic_types/read");
    if (res.code === 200) {
      setParamedics(res.data);
    }
  };

  const create_modules = (data) => {
    return data.module_clinics.map((v, k) => (
      <button key={`b-${k}`} className={"btn btn-sm btn-secondary mb-1"}>
        {v.modules.name} - {v.paramedic_types?.name ?? ""}
      </button>
    ));
  };

  const create_button = (datas) => {
    return (
      <div>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => {
            setClinic(datas);
            setModalShow(true);
          }}
        >
          edit
        </button>
      </div>
    );
  };

  return (
    <div>
      <div className="row">
        <div className="col">
          <div className="form-group row ml-3">
            <label
              htmlFor="example-text-input"
              className="col-md-2 col-form-label col-form-label-sm"
            >
              Pencarian
            </label>
            <div className="col-md-7">
              <div className="row">
                <div>
                  <input
                    className="form-control col-md-12 form-control-sm"
                    type="text"
                    name="search"
                    id="search"
                    placeholder="cari"
                    value={search}
                    onChange={(e) => {
                      setsearch(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <Table
              headers={["No", "Clinic", "Module", "Aksi"]}
              data={clinics}
              columnMapper={(data, key) => [
                data.name,
                create_modules(data),
                create_button(data),
              ]}
              pagination={true}
            />
          </div>
        </div>
      </div>
      <ModalClinicModule
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setRefreshModal(refreshModal + 1);
        }}
        resetData={getClinic}
        clinic={clinic}
        refModules={modules}
        refParamedic={paramedics}
        refreshModal={refreshModal}
      />
    </div>
  );
};

export default ClinicModule;
